module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Bold.ff1821a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Bold/SFProDisplay-Bold.woff
// module id = d9Fg
// module chunks = 16